// removed by extract-text-webpack-plugin
module.exports = {"Form":"src-components-contact----form-module---Form---2Q1eo","Form--success":"src-components-contact----form-module---Form--success---34VFa","Form__heading":"src-components-contact----form-module---Form__heading---3LUlS","Form__heading__text":"src-components-contact----form-module---Form__heading__text---qOHZn","Form__icon":"src-components-contact----form-module---Form__icon---2jwhR","Form__label":"src-components-contact----form-module---Form__label---2bNjW","Form__button":"src-components-contact----form-module---Form__button---1ozaA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/form.module.scss
// module id = 211
// module chunks = 114276838955818 184470312924441